module.exports = __webpack_public_path__ + "static/media/chameleon.718de915.jpg";